import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react'
import { cn } from '@/utils'
import { Button as BasisButton } from './basis/button'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link'
  size?: 'sm' | 'md' | 'lg'
  isLoading?: boolean
  leftIcon?: ReactNode
  rightIcon?: ReactNode
}

// Our size vocabulary (sm/md/lg) maps onto basis (sm/default/lg). Kept as an
// adapter convenience — size is not part of the vocabulary codemod.
const sizeMap = { sm: 'sm', md: 'default', lg: 'lg' } as const

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'default', size = 'md', isLoading = false, leftIcon, rightIcon, children, ...props }, ref) => (
    <BasisButton
      ref={ref}
      variant={variant}
      size={sizeMap[size]}
      loading={isLoading}
      className={cn(className)}
      {...props}
    >
      {!isLoading && leftIcon}
      {children}
      {!isLoading && rightIcon}
    </BasisButton>
  )
)

Button.displayName = 'Button'
